module.exports = __webpack_public_path__ + "media/images/wf_logo-73954f17f21d2287e4cbe7a6348d1849.png";